export interface IPvCalculateParams {
    amount: number;
    tenure: number;
    interestRate: number;
}

export const pv = (request: IPvCalculateParams): number => {
    const { amount, tenure, interestRate } = request;

    const monthlyRate = interestRate / 100;
    const interestFactor = (1 + monthlyRate) ** tenure;
    
    return (amount * (interestFactor - 1)) /
      (monthlyRate * interestFactor * tenure)
}
